export default __webpack_public_path__ + "img/oqGuZVLi.18df160c.svg";